import { RaRecord } from 'ra-core';
import { createContext } from 'react';

const DatagridContext = createContext<DatagridContextValue>({});

DatagridContext.displayName = 'DatagridContext';

type DatagridContextValue = {
  isRowExpandable?: (record: RaRecord) => boolean;
  expandSingle?: boolean;
};

export { DatagridContext };
export type { DatagridContextValue };
